import { render, staticRenderFns } from "./PowerbarNav.vue?vue&type=template&id=38155e68&"
import script from "./PowerbarNav.vue?vue&type=script&lang=ts&"
export * from "./PowerbarNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38155e68')) {
      api.createRecord('38155e68', component.options)
    } else {
      api.reload('38155e68', component.options)
    }
    module.hot.accept("./PowerbarNav.vue?vue&type=template&id=38155e68&", function () {
      api.rerender('38155e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/PowerbarNav/PowerbarNav.vue"
export default component.exports